/* eslint-disable react/no-unescaped-entities */
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  Flex,
  Image,
  Link as ChakraLink,
  Text,
  VStack,
} from '@chakra-ui/react';
//@ts-ignore
import AppVerified from '../../../assets/icons/AppVerified.svg';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import { getAppDetails } from '../../../redux/appBuilder/appDetails/selectors';
import { updateAppActiveStep } from '../../../redux/appBuilder/stepperDetails';
import { getAppType } from '../../../redux/appBuilder/stepperDetails/selectors';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useEffect } from 'react';

export const NewAppFinish = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { width } = useWindowDimensions();

  const appData = useAppSelector(getAppDetails);
  const appType = useAppSelector(getAppType);

  const handleBackAction = () => {
    dispatch(updateAppActiveStep(3));
    navigate(`/my-applications/code-preview/${appData.appId}`);
  };
  return (
    <Card
      w={width > 1740 ? '1300px' : '95%'}
      mt={6}
      variant="outline"
      borderRadius="12px"
      h="fit-content"
    >
      <CardBody p={0}>
        <VStack
          align="flex-start"
          spacing={5}
          padding={7}
          pb={0}
          h="72vh"
          overflowY="scroll"
        >
          <VStack w="100%" alignItems="center">
            <Text
              fontSize="xxx-large"
              mt="6vh"
              color="black"
              fontWeight="bold"
              fontFamily="inter"
            >
              {appType === 'ZK_FETCH' ? 'Well Done!' : 'It worked!'}
            </Text>
            <Image
              mt="16px"
              src={AppVerified}
              className="dashbaoard-image"
              bgColor="white.700"
              alt="Illustration"
            />
            <Text className="x-small-font" color="gray" fontFamily="inter">
              We can't wait to see what you build!
            </Text>
            <ChakraLink href="https://t.me/protocolreclaim" isExternal>
              <Button
                mt="8px"
                className="dashboard-button"
                _hover={{ bgColor: 'gray.800' }}
              >
                <Text fontFamily="inter" color="white" className="medium-font">
                  Apply for a Grant
                </Text>
              </Button>
            </ChakraLink>
          </VStack>
        </VStack>
        <VStack className="stepper-bar" alignItems="flex-start">
          <Flex alignItems="center" gap={3} justifyContent="space-between">
            <Button
              className="stepper-back-button small-font"
              _hover={{
                transform: 'scale(1.05)',
              }}
              onClick={handleBackAction}
            >
              Back
            </Button>
          </Flex>
        </VStack>
      </CardBody>
    </Card>
  );
};
